export default "__VITE_ASSET__CRwSffrB__"